import React from "react";
import { Link } from "gatsby";
import { menuLinks } from "../common/utils/page_url_utils";
import { ScrollToDiv } from "../common/utils/site_utlis";

const BtnModule = (props) => {

    var page_link = props?.button_cta?.custom_link ? props.button_cta?.custom_link : props?.button_cta?.menu_item?.slug ? menuLinks(props.button_cta.menu_item) : "";

    var class_name = props?.button_cta?.link_type === "menu_link" ? "btn-link" : props?.button_cta?.theme === "outline" ? "btn btn-outline" : props?.button_cta?.theme === "primary" ? "btn btn-primary"  : props?.button_cta?.theme === "secondary" ? "btn btn-secondary" : props?.button_cta?.theme === "anchor_link" ? "btn-link" : "btn"

    return(
        <>
        {page_link ? 
            (page_link.indexOf("#") > -1 ?
                <a href="javascript:;" onClick={() => ScrollToDiv(page_link.replace("#", ''))} className={`${class_name} ${props.className}`}>  
                    {props?.button_cta?.label}
                </a>
            :
                <Link className={`${class_name} ${props.className}`} to={page_link} target={props?.button_cta?.target === "new_window" ? "_blank" : "_self"}>  
                    {props?.button_cta?.label}
                </Link>
            )
        :
            props?.button_cta?.label && 
            <a href="javascript:;" className={`${class_name} ${props.className}`} target={props?.button_cta?.target === "new_window" ? "_blank" : "_self"}>  
                {props?.button_cta?.label}
            </a>
        }
        </>
    )
}
export default BtnModule;